import React, { FC } from 'react';
import cn from 'classnames';
import styles from './TableCell.module.css';

interface TableCellProps {
  children?: React.ReactNode;
  header?: boolean;
}

const TableCell: FC<TableCellProps> = ({ children, header = false }) => {
  if (header) {
    return (
      <th className={cn(styles.cellWrapper)}>
        <div className="d-flex align-items-center">{children}</div>
      </th>
    );
  }

  return (
    <td className={cn(styles.cellWrapper)}>
      <div>{children}</div>
    </td>
  );
};

export default TableCell;
